import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { PersonalParticularModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[TeamOrgChart] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[TeamOrgChart] Load items success', props<{ data: PaginationAdapter<PersonalParticularModel> }>());

// item
export const loadItem = createAction('[TeamOrgChart] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[TeamOrgChart] Load item success', props<{ item: PersonalParticularModel }>());
